export const TOAST_DURATION_MS = 3000

export const GLOBAL_TOAST_DURATION_MS = 4000

export const TOAST_COLORS = {
	SUCCESS: 'success' as const,
	DANGER: 'danger' as const,
	WARNING: 'warning' as const,
	PRIMARY: 'primary' as const,
}
